import { ObjectConfig, ObjectConfigStatus } from './interfaces/object';
import { ObjectField } from './interfaces/object-field';

export function objectHasDisabledStatus(status: ObjectConfigStatus) {
  return ![ObjectConfigStatus.ACTIVE, ObjectConfigStatus.INACTIVE].includes(status);
}

export function isObjectEditable(object: ObjectConfig) {
  return object.isEditable;
}

export function shouldRenderObjectConfigCell(object: ObjectConfig, columnKey: string) {
  return object.isConfigurable || !['keys', 'fieldCount', 'loadMode'].includes(columnKey);
}

export function shouldRenderFieldConfigCell(
  field: ObjectField,
  columnIndex: number,
  columnsLength: number
) {
  return field.isConfigurable || columnIndex === 0 || columnIndex === columnsLength - 1;
}
